import React from 'react';
import { useT } from '@repo/common';

const STEPS = [
  { label: 'Profile', labelKr: '프로필' },
  { label: 'Education', labelKr: '학력' },
  { label: 'Experience', labelKr: '경력' },
  { label: 'Skills', labelKr: '스킬' },
  { label: 'Activity', labelKr: '활동' },
  { label: 'Link', labelKr: '링크' },
];

const StepHeader = ({ currentStep, setCurrentStep }) => {
  const t = useT();
  return (
    <div className='w-full bg-transparent max-w-[1000px] flex items-start content-start'>
      <div className='flex flex-wrap items-center max-w-[1000px] w-full gap-x-0 gap-y-3'>
        {STEPS.map((step, index) => {
          const isActive = index === currentStep;

          return (
            <div
              key={step.label}
              className={`relative flex-1 min-w-[140px] max-w-[320px] w-full h-[26px] flex flex-col gap-1 
                items-center justify-start border-b-[1.5px] border-grayscale-gray01
                ${isActive && ''}`}
            >
              <button
                onClick={() => {
                  setCurrentStep(index);
                }}
                className={`typo-b14Strong ${isActive ? 'text-text-primary' : 'text-text-secondary'}`}
              >
                {t(step.label, step.labelKr)}
              </button>
              {isActive && (
                <div className='absolute bottom-[-1.5px] w-20 h-0.5 rounded-[10px] shrink-0 bg-green-deep01' />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StepHeader;
